import { useMutation } from '@apollo/client';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.js';
import { gql } from '@/__generated__';
import { meQuery } from '@/routes/_app/loader';

const AcceptPrivacyPolicy = gql(`
  mutation AcceptPrivacyPolicy {
    acceptPrivacyPolicy {
      id
      acceptedPrivacyPolicy
    }
  }
`);

export const useAcceptPrivacyPolicy = () => {
  const toast = useToast();

  const [mutate, result] = useMutation(AcceptPrivacyPolicy, {
    onError(error) {
      toast.error({
        title: 'Failed to accept privacy policy',
        subTitle: error?.message || 'Please try again',
      });
    },

    update(cache, { data }) {
      if (data?.acceptPrivacyPolicy) {
        const existingMeData = cache.readQuery({
          query: meQuery,
        });

        if (existingMeData?.me) {
          cache.writeQuery({
            query: meQuery,
            data: {
              me: {
                ...existingMeData.me,
                acceptedPrivacyPolicy:
                  data.acceptPrivacyPolicy.acceptedPrivacyPolicy,
              },
            },
          });
        }
      }
    },
  });

  const acceptPrivacyPolicy = () => {
    return mutate({
      optimisticResponse: {
        acceptPrivacyPolicy: {
          __typename: 'User',
          id: '',
          acceptedPrivacyPolicy: true,
        },
      },
    });
  };

  return [acceptPrivacyPolicy, result] as const;
};
